import { useMutation, useQuery } from "react-query";

import { saveFile, deleteFile, getPurchasePreview } from "@/api/Purchases/purchases";

const key = "purchases";

// DOCS
export function useSaveDocument() {
	return useMutation(saveFile);
}

export function useDelDocument() {
	return useMutation(deleteFile);
}

export function usePurchasePreview(params) {
	return useQuery([key, { ...params }], () => getPurchasePreview(params), {
		enabled: params.show,
	});
}
